/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SwitchReq1
 */
export interface SwitchReq1 {
    /**
     * 目标启用状态：0停用、1启用。
     * @type {number}
     * @memberof SwitchReq1
     */
    enable: number;
}

/**
 * Check if a given object implements the SwitchReq1 interface.
 */
export function instanceOfSwitchReq1(value: object): value is SwitchReq1 {
    if (!('enable' in value) || value['enable'] === undefined) return false;
    return true;
}

export function SwitchReq1FromJSON(json: any): SwitchReq1 {
    return SwitchReq1FromJSONTyped(json, false);
}

export function SwitchReq1FromJSONTyped(json: any, ignoreDiscriminator: boolean): SwitchReq1 {
    if (json == null) {
        return json;
    }
    return {
        
        'enable': json['enable'],
    };
}

export function SwitchReq1ToJSON(json: any): SwitchReq1 {
    return SwitchReq1ToJSONTyped(json, false);
}

export function SwitchReq1ToJSONTyped(value?: SwitchReq1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enable': value['enable'],
    };
}

